/**
 * src/shell/save/apikey.ts — BYOK Key 管理（设计稿 S2 系统设置 / 铁律 1）。
 *
 * 铁律：Key 永不进代码、永不进 bundle、永不进导出/任何 dump。
 * 两种存储模式：localStorage（持久）/ sessionStorage（仅本次会话）。
 * keyProvider 注入引擎 ApiClient（引擎 §8：外壳读 thirdplay:v2:apikey 注入）。
 */

import { APIKEY_KEY, APIKEY_MODE_KEY } from './keys'

export type KeyMode = 'local' | 'session'

export function getKeyMode(): KeyMode {
  return localStorage.getItem(APIKEY_MODE_KEY) === 'session' ? 'session' : 'local'
}

/** sessionStorage 在无窗口环境（Node 测试）下不存在——守卫后视为无此存储 */
function sessionStore(): Storage | null {
  return typeof sessionStorage === 'undefined' ? null : sessionStorage
}

/** 读 Key（两模式都查；引擎 keyProvider 唯一入口） */
export function readApiKey(): string | null {
  return sessionStore()?.getItem(APIKEY_KEY) ?? localStorage.getItem(APIKEY_KEY)
}

export function hasApiKey(): boolean {
  return readApiKey() !== null
}

/** 写入 Key：按模式存放，另一处清除，杜绝双副本 */
export function writeApiKey(key: string, mode: KeyMode): void {
  const trimmed = key.trim()
  if (mode === 'local') {
    localStorage.setItem(APIKEY_KEY, trimmed)
    sessionStore()?.removeItem(APIKEY_KEY)
  } else {
    sessionStore()?.setItem(APIKEY_KEY, trimmed)
    localStorage.removeItem(APIKEY_KEY)
  }
  localStorage.setItem(APIKEY_MODE_KEY, mode)
}

/** 一键清除（两处都清） */
export function clearApiKey(): void {
  localStorage.removeItem(APIKEY_KEY)
  sessionStore()?.removeItem(APIKEY_KEY)
  localStorage.removeItem(APIKEY_MODE_KEY)
}
